export const cleverTapEvents = {
    PageVisit: {
      name: "rewards",
      attributes: {
        status: {
          start: { rewards_landing: "START" },
          success: { rewards_landing: "SUCCESS" },
          failed: { rewards_landing: "ERROR" },
        },
        rewards_see_details: {
          see_details: "SUCCESS",
          cta_label: "See Details",
        },
        rewards_history: {
          rewards_history: "SUCCESS",
          cta_label: "rewards_history_icon",
        },
        rewards_scratch_close: {
          rewards_scratch_close: "SUCCESS",
          cta_label: "rewards_history_icon",
        },
        rewards_scratch_open: {
          rewards_scratch_open: "SUCCESS",
          cta_label: "rewards_history_icon",
        },
      },
    },
    Referrals: {
      name: "idfc_referral",
      attributes: {
        REFERRAL_BANNER: { step: "referral_banner" },
        REFERRAL_MENU: { step: "referral_menu" },
        FIRST_TIME: { step: "first_time" },
        REPEAT_USER: { step: "repeat_user" },
        REFERRAL_EARNINGS: { step: "referral_earnings" },
        REFREES_REGISTERED: { step: "referees_registered" },
        REFREES_ACTIVATED: { step: "referees_activated" },
        SHARE_CODE: { step: "share_code" },
        COPY_CODE: { step: "copy_code" },
        EDIT_CODE: { step: "edit_code" },
        EDIT_CODE_SUCCESS: { step: "edit_code_success" },
        EDIT_CODE_FAILURE: (error) => {
          return { error: "edit_code_failure : " + error };
        },
        SUGGESTED_CODE: { step: "suggested_code" },
        REFERRAL_SECTION: { step: "referral_section" },
        REFERRAL_HISTORY: { step: "referral_history" },
        SCRATCH_CARD: { step: "scratch_card" },
        SKIP_ENTERING_CODE: { step: "skip_entering_code" },
        ENTER_VALID_CODE: { step: "enter_valid_code" },
        ENTER_INVALID_CODE: { step: "enter_invalid_code" },
        CONFIRM_VAID_CODE: { step: "confirm_valid_code" },
      },
    },
    wealthMfOnboarding: {
      name: "wealth_mf_onboarding",
      section: {
        ONBOARDING_LOADER: (serverError = "", clientError = "") => ({
          section: "loader",
          flow_status: "begin",
          step: "onboarding_pwa",
          action: "load",
          ...commonAttributes(serverError, clientError),
        }),
        EMAIL_VERIFICATION_LOAD: (serverError = "", clientError = "") => ({
          section: "email_verification",
          flow_status: "begin",
          step: "verify_email",
          action: "load",
          ...commonAttributes(serverError, clientError),
        }),
        EMAIL_VERIFICATION_SEND_OTP: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "email_verification",
          step: "verify_email",
          cta: "send_otp",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        EMAIL_VERIFICATION_RESEND_OTP: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "email_verification",
          step: "enter_otp",
          cta: "resend_otp",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        EMAIL_VERIFICATION_VERIFY: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "email_verification",
          step: "enter_otp",
          cta: "verify",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        EMAIL_VERIFICATION_COMPLETE: (
          status,
          serverError = "",
          clientError = ""
        ) => ({
          section: "email_verification",
          step: "enter_otp",
          flow_status: "complete",
          status,
          ...commonAttributes(serverError, clientError),
        }),
        PHONE_VERIFICATION_LOAD: (serverError = "", clientError = "") => ({
          section: "phone_verification",
          flow_status: "begin",
          step: "verify_phone",
          action: "load",
          ...commonAttributes(serverError, clientError),
        }),
        PHONE_VERIFICATION_SEND_OTP: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "phone_verification",
          step: "verify_phone",
          cta: "send_otp",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        PHONE_VERIFICATION_RESEND_OTP: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "phone_verification",
          step: "enter_otp",
          cta: "resend_otp",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        PHONE_VERIFICATION_VERIFY: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "phone_verification",
          step: "enter_otp",
          cta: "verify",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        PHONE_VERIFICATION_COMPLETE: (
          status,
          serverError = "",
          clientError = ""
        ) => ({
          section: "phone_verification",
          step: "enter_otp",
          flow_status: "complete",
          status,
          ...commonAttributes(serverError, clientError),
        }),
        SCREEN_LOADER: (serverError = "", clientError = "") => ({
          section: "loader",
          step: "loader",
          action: "load",
          ...commonAttributes(serverError, clientError),
        }),
        KYC_STATUS_CHECK: (
          onboardingKycStatus,
          userStatus,
          serverError = "",
          clientError = ""
        ) => ({
          section: "loader",
          step: "kyc_status_check",
          onboarding_kyc_status: onboardingKycStatus,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_DETAILS_CHECK: (
          accountDetailsAvailable,
          serverError = "",
          clientError = ""
        ) => ({
          section: "loader",
          step: "account_details_check",
          account_details_available: accountDetailsAvailable,
          ...commonAttributes(serverError, clientError),
        }),
        LOCATION_CHECK: (location, serverError = "", clientError = "") => ({
          section: "loader",
          step: "location_check",
          location,
          ...commonAttributes(serverError, clientError),
        }),
        PENNY_TESTING: (status, serverError = "", clientError = "") => ({
          section: "loader",
          step: "penny_testing",
          status,
          ...commonAttributes(serverError, clientError),
        }),
        DOCUMENTS_CHECK: (docStatus, serverError = "", clientError = "") => ({
          section: "loader",
          step: "documents_check",
          doc_status: docStatus,
          ...commonAttributes(serverError, clientError),
        }),
        PAN_DETAILS: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "pan_details",
          submit: true,
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        PAN_VERIFICATION: (
          cta,
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "pan_details",
          cta,
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        PAN_VERIFICATION_DOB: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "pan_details",
          cta: "re-enter_dob",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
  
        BASIC_DETAILS: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "basic_details",
          cta: "submit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        KYC_DETAILS: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "kyc_details",
          cta: "submit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
  
        BANK_DETAILS: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "bank_details",
          cta: "submit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DETAILS_PENNY_TEST: (
          cta,
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "penny_testing",
          cta: cta,
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DETAILS_PENNY_TEST_STATUS: (
          status,
          userStatus,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "penny_testing",
          status,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DETAILS_CHANGE_BANK: (
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "bank_details",
          cta: "change_bank",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
  
        NOMINEE_DETAILS: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "nominee_details_check",
          cta: "submit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        NOMINEE_DETAILS_UPDATE:(userStatus,
          ctaLabel,
          serverError = "",
          clientError = "")=>({
            section: "account_details",
          step: "nominee_details_check",
          cta: "submit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
          }),
        REVIEW: (userStatus, ctaLabel, serverError = "", clientError = "") => ({
          section: "account_details",
          step: "review",
          cta: "submit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ALLDONE: (userStatus, serverError = "", clientError = "") => ({
          section: "ALLDONE",
          step: "ALLDONE",
          cta: "Reached AllDone",
          user_status: userStatus,
          cta_label: "ALl Done",
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_DETAILS_COMPLETE_ONLOAD: (
          flowStatus,
          userStatus,
          sectionComplete,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          flow_status: flowStatus,
          user_status: userStatus,
          section_complete: sectionComplete,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_DETAILS_COMPLETE: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "section_complete",
          cta: "continue",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_DETAILS_COMPLETE_INVEST: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "section_complete",
          cta: "invest",
          flowStatus: "begin",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_DETAILS_COMPLETE_EDIT: (
          userStatus,
          ctaLabel,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "account_details",
          cta,
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ONLINE_KYC_COMPLETE_ONLOAD: (
          flowStatus,
          userStatus,
          sectionComplete,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow_status: flowStatus,
          user_status: userStatus,
          section_complete: sectionComplete,
          ...commonAttributes(serverError, clientError),
        }),
        ONLINE_KYC_COMPLETE: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          step: "section_complete",
          cta: "continue",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ONLINE_KYC_COMPLETE_INVEST: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          step: "section_complete",
          cta: "invest",
          flowStatus: "begin",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        REDIRECT_SIGNZY: (userStatus, serverError = "", clientError = "") => ({
          section: "online_kyc",
          step: "redirect_signzy",
          action: "load",
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        SIGN_ACTION_CLICK: (
          userStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "sign",
          flow: "onboarding",
          product: "wealth_mf",
          step: "sign",
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        BANK_DOCUMENT_ACTION_CLICK: (
          userStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "bank_doc",
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DOCUMENT_PASSWORD_PROTECTED: (
          userStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "bank_doc",
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
  
        PAN_DIGILOCKER_MISMATCH:(
          userStatus,
          ctaLabel,
          serverError= "",
          clientError=""
        )=>({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "digilocker",
          cta:"Digilocker PAN Error",
          cta_label:ctaLabel,
          user_status:userStatus,
          ...commonAttributes(serverError, clientError),
  
        }),
        ESIGN_DOCUMENT_INFO_CLICK: (
          infoType,
          infoContent,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "esign",
          info_ui_type: infoType,
          info_content: infoContent,
          ...commonAttributes(serverError, clientError),
        }),
  
        ESIGN_DOCUMENT_ACTION_CLICK: (
          userStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "esign",
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        LOADER_CLICK: (userStatus, cta, serverError = "", clientError = "") => ({
          section: "loader",
          flow: "onboarding",
          product: "wealth_mf",
          step: "loader",
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        DIGILOCKER_ACTION_CLICK: (
          userStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "digilocker",
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        DIGILOCKER_WAITING_ACTION_CLICK: (
          userStatus,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "Digilocker_waiting",
          cta: "got_it",
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        DIGILOCKER_INFO_CLICK: (
          infoType,
          infoContent,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step: "digilocker",
          info_ui_type: infoType,
          info_content: infoContent,
          ...commonAttributes(serverError, clientError),
        }),
  
        DIGILOCKER_REDIRECT: (
          status,
          userStatus,
          serverError = "",
          clientError = ""
        ) => {
          if (status) {
            return {
              section: "online_kyc",
              flow: "onboarding",
              product: "wealth_mf",
              step: "digilocker_redirect",
              status,
              userStatus,
              ...commonAttributes(serverError, clientError),
            };
          }
          return {
            section: "online_kyc",
            flow: "onboarding",
            product: "wealth_mf",
            step: "digilocker_redirect",
            userStatus,
            ...commonAttributes(serverError, clientError),
          };
        },
  
        LIVELINESS_ACTION: (
          userStatus,
          cta,
          step,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step,
          cta,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        LIVELINESS_RESPONSE: (
          userStatus,
          status,
          step,
          serverError = "",
          clientError = ""
        ) => ({
          section: "online_kyc",
          flow: "onboarding",
          product: "wealth_mf",
          step,
          status,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
  
        SIGN_SECTION_UPLOAD: (
          userStatus,
          ctaLabel,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "sign",
          step: "sign",
          cta,
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        SIGN_SECTION_UPLOAD_STATUS: (
          userStatus,
          uploadStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "sign",
          step: "sign",
          user_status: userStatus,
          upload_status: uploadStatus,
          ...commonAttributes(serverError, clientError),
        }),
        SIGN_SECTION_ONLOAD: (
          flowStatus,
          sectionComplete,
          userStatus,
          serverError = "",
          clientError = ""
        ) => ({
          section: "sign",
          section_complete: sectionComplete,
          flowStatus: flowStatus,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
        SIGN_SECTION_COMPLETE: (
          ctaLabel,
          userStatus,
          serverError = "",
          clientError = ""
        ) => ({
          section: "sign",
          step: "section_complete",
          user_status: userStatus,
          cta: "continue",
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        SIGN_SECTION_COMPLETE_INVEST: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "sign",
          step: "section_complete",
          cta: "invest",
          flowStatus: "begin",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DOCUMENT_UPLOAD: (
          userStatus,
          ctaLabel,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          step: "bank_doc",
          cta,
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DOCUMENT_UPLOAD_STATUS: (
          userStatus,
          uploadStatus,
          cta,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          step: "bank_doc",
          user_status: userStatus,
          upload_status: uploadStatus,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DOCUMENT_ONLOAD: (
          flowStatus,
          userStatus,
          sectionComplete,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          flow_status: flowStatus,
          user_status: userStatus,
          section_complete: sectionComplete,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DOCUMENT_COMPLETE: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          step: "section_complete",
          cta: "continue",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DOCUMENT_COMPLETE_INVEST: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "bank_doc",
          step: "section_complete",
          cta: "invest",
          flowStatus: "begin",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_ACTIVATION_CHECKLIST: (
          userStatus,
          sectionClicked,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_activation_checklist",
          section_clicked: sectionClicked,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_ACTIVATION_CHECKLIST_STEP: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_activation_checklist",
          step: "account_activation_checklist",
          cta: "continue",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_ACTIVATION_ACTION_REQUIRED: (
          userStatus,
          sectionClicked,
          serverError = "",
          clientError = ""
        ) => ({
          section: "action_required_checklist",
          section_clicked: sectionClicked,
          user_status: userStatus,
          ...commonAttributes(serverError, clientError),
        }),
        ACCOUNT_ACTIVATION_EDIT: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "account_details",
          cta: "edit",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        NRI_ERROR_SCREEN: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "kyc_status_check",
          cta: "got_it",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        LOCATION_NOT_INDIA_ERROR: (
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        ) => ({
          section: "account_details",
          step: "location_check",
          cta: "got_it",
          user_status: userStatus,
          cta_label: ctaLabel,
          ...commonAttributes(serverError, clientError),
        }),
        // Photo mismatch
        ONLINE_KYC:(
          userStatus,
          ctaLabel,
          serverError = "",
          clientError = ""
        )=>({
          section:"online_kyc",
          cta:ctaLabel,
          user_status:userStatus,
          ...commonAttributes(serverError, clientError),
        })
      },
    },
  
    wealthMfInfo: {
      name: "wealth_mf_info",
      section: {
        PAN_DETAILS_INFO: (serverError = "", clientError = "") => ({
          step: "pan_details",
          info_ui_type: "info_bubble",
          info_content: "residency_status",
          ...commonAttributes(serverError, clientError),
        }),
        KYC_DETAILS_INFO: (serverError = "", clientError = "") => ({
          step: "kyc_details",
          info_ui_type: "info_bubble",
          info_content: "politically_exposed",
          ...commonAttributes(serverError, clientError),
        }),
        BANK_DETAILS_INFO: (serverError = "", clientError = "") => ({
          step: "bank_details",
          info_ui_type: "info_bubble",
          info_content: "account_holder_name",
          ...commonAttributes(serverError, clientError),
        }),
        NRI_DETAILS_INFO: (serverError = "", clientError = "") => ({
          step: "nri_details",
          info_ui_type: "info_bubble",
          info_content: "tax_resident",
          ...commonAttributes(serverError, clientError),
        }),
      },
    },
  };
  
  const commonAttributes = (serverError, clientError) => {
    let source = sessionStorage.getItem("source");
    let app_name = "";
    if (source === "NIYO_SBM") app_name = "niyo_sbm";
    let attributes = {
      app_name,
    };
  
    if (serverError || clientError) {
      attributes = {
        ...attributes,
        error: true,
        error_desc: serverError,
        error_ui_text: clientError,
      };
    }
  
    return attributes;
  };
  